<script lang="ts" setup>
definePageMeta({
  layout: 'basic',
  title: 'Redirecting'
})

useHead({
  script: [
    {
      tagPosition: 'bodyClose',
      innerHTML: `
        function onCannyLoad() {
          const linkNode = document.getElementById('canny-link')
          const user = Object.fromEntries(new URLSearchParams(location.search));

          const data = {
            appID: '6590031274d23109363be88e',
            user
          };

          console.log('Identifying Canny', data);
          Canny('identify', data, () => linkNode.click());
        }
      `
    },
    {
      src: 'https://canny.io/sdk.js',
      tagPosition: 'bodyClose',
      async: true,
      onload: 'onCannyLoad()'
    }
  ]
})
</script>

<template>
  <section class="p-5 flex-col-center text-base text-center text-neutral-800">
    <img src="@assets/images/branding/logo-animated.svg" width="84">
    <h4 class="mt-4 text-base text-neutral-400 font-medium">
      Redirecting...
    </h4>
    <a
      id="canny-link" aria-hidden="true" class="invisible" data-canny-link
      href="https://vocal.canny.io/feature-requests" target="_top"
    >
      Give feedback
    </a>

    <noscript class="text-lg text-neutral-500 font-medium">
      Please enable Javascript
    </noscript>
  </section>
</template>
